import { z } from "zod";

/*
 * Device token contract shared by server and UI. Tokens authenticate OPDS clients only.
 */

export const DEVICE_TOKEN_NAME_MAX = 64;
export const DEVICE_TOKEN_LIMIT = 25;

/** `POST /api/me/device-tokens`. */
export const deviceTokenCreateSchema = z.object({
  name: z
    .string({ error: "required" })
    .trim()
    .min(1, { error: "name_required" })
    .max(DEVICE_TOKEN_NAME_MAX, { error: "too_long" }),
});
export type DeviceTokenCreateInput = z.input<typeof deviceTokenCreateSchema>;

export interface DeviceTokenDto {
  id: string;
  name: string;
  /** First characters of the token, for recognition only. */
  start: string;
  createdAt: string;
  /** `null` while the token has never been used. */
  lastUsedAt: string | null;
}

export interface DeviceTokenCreatedDto extends DeviceTokenDto {
  /** The full token; only returned by the creating request. */
  token: string;
}

export interface DeviceTokenListDto {
  tokens: DeviceTokenDto[];
}
